import { TimeUnits } from "@hotelchamp/common";

export enum CheckoutSessionDefaults {
    SessionTtl = TimeUnits.Minute * 15, // 15 minutes
}
